import { Divider, Card, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Page from '../../components/Page';
import PasswordCard from './PasswordCard';
import InformationCard from './InformationCard';
import RoleCard from './RoleCard';
import { getProfile, getUserRole } from './utils/serviceCalls';

function Index({ dispatch }) {
  const [profile, setProfile] = useState(null);
  const [roles, setRoles] = useState([]);
  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    getUserRole(
      {},
      (data) => {
        setRoles(data);
      },
      () => { }
    );
    getProfile(
      {},
      (data) => {
        setProfile(data);
      },
      () => { }
    );
  }

  function refreshData() {
    getProfile(
      {},
      (data) => {
        setProfile(data);
        dispatch({ type: 'SET_USER_PROFILE', payload: data[0] });
      },
      () => { }
    );
    getUserRole(
      {},
      (data) => {
        setRoles(data);
      },
      () => { }
    );
  }

  return (
    <Page title="Profile | Genius">
      {profile && (
        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'center',
            p: 2
          }}
        >
          <Card 
            sx={{ 
              p: 3,
              width: {
                xs: '100%',
                sm: '100%',
                md: '100%',
                lg: '50%',
                xl: '50%'
              }
            }}
          >
            <InformationCard profile={profile[0]} refreshData={refreshData} />
            <Divider sx={{ my: 5 }} />
            <PasswordCard />
            <Divider sx={{ my: 5 }} />
            {roles.length > 1 && (
              <RoleCard roles={roles} />
            )}
          </Card>
        </Box>
      )}
    </Page>
  );
}

Index.propTypes = {
  dispatch: PropTypes.func
};

export default connect(() => ({}))(Index);
